<template>
  <div class="bg-light">
    <h6 v-if="typeof title !== 'undefined' && title != ''">{{ title }}</h6>

    <template v-if="show_result">
      <template v-if="expand">
        <table :class="'table table-sm table-hover table-responsive-sm table-12 table-bordered' + tableClass">
          <tbody>
          <tr>
            <th class="text-center">Наименование</th>
            <th class="text-center">Расшифровка</th>
            <th class="text-center">Значение</th>
          </tr>
          <template v-for="(item, index) in rows">
            <tr :key="index" v-if="(item.show_null || data[item.name] != 0) && (show_result || item.tax)" :class="item.class">
              <td>
                <b-form-checkbox v-if="!expand && item.tax" size="sm" v-model="tax[item.name]" value="1"
                                 unchecked-value="0" v-b-tooltip.leftbottom :title="item.title_full"><span style="font-size: 12px;">{{item.title}} <strong class="text-danger" v-if="tax[item.name] == 0">ОТКЛЮЧЕН!</strong></span> </b-form-checkbox>
                <span>{{item.title_full}}</span>

              </td>

              <td>
                <SalaryDescription :description="data[item.name + '_description']"></SalaryDescription>
              </td>
              <td class="text-right">{{ formatMoney(data[item.name], 2) }}</td>
            </tr>
          </template>
          </tbody>
        </table>
          <div class="text-right">
              <slot />
          </div>
      </template>

      <template v-else>

        <div class="row">
          <div class="col-5">
            <div class="text-center">
              <p>Присоединяйтесь к нашему сообществу в Whatsapp</p>
              <img src="images/chat_qr.png" alt="" style="height: 200px" />
            </div>
          </div>
          <div class="col-7">
            <div class="row">
              <div class="col-7">
                <table class="table table-sm table-12">
                  <tbody>
                  <tr>
                    <th class="text-center">Заработная плата</th>
                    <th class="text-center">Значение</th>
                  </tr>

                  <template v-for="(item, index) in rows">
                    <tr :key="index" v-if="(item.show_null || data[item.name] != 0) && !item.tax" :class="item.class">
                      <td>
                        <span>{{item.title}}</span>

                      </td>

                      <td class="text-right">{{ formatMoney(data[item.name], 2) }}</td>
                    </tr>
                  </template>
                  </tbody>
                </table>
              </div>
              <div class="col-5">
                <table class="table table-sm table-12">
                  <tbody>
                  <tr>
                    <th class="text-center">Налоги взносы и отчисления</th>
                    <th class="text-center">Значение</th>
                  </tr>

                  <template v-for="(item, index) in rows">


                    <tr :key="index" v-if="(item.show_null || data[item.name] != 0) && item.tax" :class="item.class">
                      <td class="py-0">
                        <b-form-checkbox size="sm" v-model="tax[item.name]" value="1"
                                         unchecked-value="0" v-b-tooltip.leftbottom :title="item.title_full"><span style="font-size: 12px;">{{item.title}} <strong class="text-danger" v-if="tax[item.name] == 0">ОТКЛЮЧЕН!</strong></span> </b-form-checkbox>
                      </td>
                      <td class="text-right">{{ formatMoney(data[item.name], 2) }}</td>
                    </tr>
                  </template>
                  </tbody>
                </table>
              </div>

            </div>
          </div>
          <div class="col-6"><div class="h5">РАСЧЁТ ЗА {{month.toUpperCase()}} {{year}} ГОДА | ИТОГО НА РУКИ: {{formatMoney(data.worker, 2)}} тг.</div></div>
          <div class="col-6 text-right"><slot /></div>

        </div>

      </template>

    </template>
  </div>

</template>


<script>
import SalaryDescription from "@/components/base/SalaryDescription"
import {mapGetters} from "vuex";
//import SalaryLaws from "@/components/calc/Laws"

export default {
  name: 'CalcDescription',
  components: {
    SalaryDescription
  },
  props: {
    title: String,
    data: Object,
    laws: Boolean,
    expand: Boolean,
    tableClass: String,
    tax: Object,
    show_result: Boolean,
    wait: Boolean,
    year: {
      default: ''
    },
    month: String
  },
  data: function () {
    return {
      rows: [
        {name: 'adjustment', title: 'Корректировка/Облагаемый доход 90%', title_full: 'Корректировка 90%/Облагаемый доход 90% для дохода менее 25 МРП', show_null: true, class: ''},
        {name: 'sum', title: 'Начислено', title_full: 'Начислено работнику', show_null: true, class: ''},
        {name: 'deduction', title: 'Удержания', title_full: 'Удержания', show_null: false, class: ''},
        {name: 'paid', title: 'Уже выплачено', title_full: 'Уже выплачено авансом работнику в этом месяце', show_null: false, class: ''},
        {name: 'worker', title: 'На руки', title_full: 'Чистыми на руки', show_null: true, class: 'font-weight-bold'},
        {name: 'employer', title: 'Затраты работодателя', title_full: 'Затраты работодателя на работника', show_null: true, class: ''},
        {name: 'opv', title: 'ОПВ', title_full: 'Обязательные пенсионные взносы', show_null: true, tax: true, class: 'bg-light'},
        {name: 'opvr', title: 'ОПВР', title_full: 'Обязательные пенсионные взносы работодателя', show_null: true, tax: true, class: 'bg-light'},
        {name: 'oppv', title: 'ОППВ', title_full: 'Обязательные профессиональные пенсионные взносы', show_null: true, tax: true, class: 'bg-light'},
        {name: 'ipn', title: 'ИПН', title_full: 'Индивидуальный подоходный налог', show_null: true, tax: true, class: 'bg-light'},
        {name: 'sn', title: 'СН', title_full: 'Социальный налог', show_null: true, tax: true, class: 'bg-light'},
        {name: 'so', title: 'СО', title_full: 'Социальные отчисления', show_null: true, tax: true, class: 'bg-light'},
        {name: 'oosms', title: 'ООСМС', title_full: 'Отчисления на обязательное социальное медицинское страхование', show_null: true, tax: true, class: 'bg-light'},
        {name: 'vosms', title: 'ВОСМС', title_full: 'Взносы на обязательное социальное медицинское страхование', show_null: true, tax: true, class: 'bg-light'},
        {name: 'tax_worker', title: 'Налоги работника', title_full: 'Налоги, взносы и отчисления, удерживаемые с работника', show_null: true, class: ''},
        {name: 'tax_employer', title: 'Налоги работодателя', title_full: 'Налоги, взносы и отчисления, удерживаемые с работодателя', show_null: true, class: ''}
      ]
    }
  },
  computed: {
    ...mapGetters({
      user: 'user'
    })
  }
}
</script>


<style>

</style>